module.exports = __webpack_public_path__ + "static/media/bandas-plata-borde.84bc9711.png";